import * as React from "react";
import { Notify } from "@/components/ui/notify";
import { LineCard } from "./line-card/LineCard";
import type { DashboardLineView } from "@/types/dashboard.types";
import type { MachineDetail } from "@/types/lines.types";

interface Props {
  lines: DashboardLineView[];
  expandedIds: Set<string>;
  onToggleExpand: (id: string) => void;
  onMachineClick: (m: MachineDetail, lineId: string) => void;
  selectedIds: Set<string>;
  onToggleSelect: (id: string) => void;
  emptyFiltered?: boolean;
}

export function LineList({
  lines,
  expandedIds,
  onToggleExpand,
  onMachineClick,
  selectedIds,
  onToggleSelect,
  emptyFiltered = false,
}: Props): React.ReactElement {
  if (lines.length === 0) {
    return (
      <Notify.Empty
        title={emptyFiltered ? "Nenhuma linha encontrada" : "Nenhuma linha cadastrada"}
        description={
          emptyFiltered
            ? "Ajuste os filtros ou a busca para ver linhas."
            : "Comece criando sua primeira linha de produção."
        }
      />
    );
  }

  return (
    <div className="space-y-3">
      {lines.map((line) => (
        <LineCard
          key={line.id}
          line={line}
          expanded={expandedIds.has(line.id)}
          onToggleExpand={() => onToggleExpand(line.id)}
          onMachineClick={(m) => onMachineClick(m, line.id)}
          selected={selectedIds.has(line.id)}
          onToggleSelect={() => onToggleSelect(line.id)}
        />
      ))}
    </div>
  );
}
